import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useEmpresaSelecionada } from '../../contexts/EmpresaContext';

const CHAVE_MENU = 'storeflow.menu.recolhido';

export default function AppLayout({ children }) {
  const { idEmpresa } = useEmpresaSelecionada();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [recolhido, setRecolhido] = useState(() => localStorage.getItem(CHAVE_MENU) === '1');

  useEffect(() => {
    localStorage.setItem(CHAVE_MENU, recolhido ? '1' : '0');
  }, [recolhido]);

  const alternarMenu = () => {
    if (window.innerWidth < 992) setMobileOpen((o) => !o);
    else setRecolhido((r) => !r);
  };

  return (
    <div className={`sf-app d-lg-flex ${recolhido ? 'sf-collapsed' : ''}`}>
      <Sidebar
        mobileOpen={mobileOpen}
        recolhido={recolhido}
        onToggleRecolhido={() => setRecolhido((r) => !r)}
        onNavigate={() => setMobileOpen(false)}
      />
      <div className="sf-content">
        <Navbar onToggleSidebar={alternarMenu} />
        {/* key={idEmpresa} remonta a página ao trocar de empresa no seletor do super admin —
            cada tela recarrega os próprios dados do zero sem precisar de reload da aba inteira. */}
        <main className="sf-main" key={idEmpresa}>{children}</main>
      </div>
    </div>
  );
}
